import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpParams } from '@angular/common/http';
declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class Utility {

  private static _isoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?Z$/;

  static copy<T>(source: any): T {
    var cloneDeep = require('lodash.clonedeep');
    return cloneDeep(source);
  }

  static copyArray(obj: any): any {
    return <any>Object.values($.extend(true, {}, obj));
  }
  static mapObject<Source, Destination>(source: Source, destination: Destination, keepProperty: boolean = false): Destination {
    Object.keys(destination)?.forEach((key) => {
      try {
        if (this.IsStringNotNullOrEmpty(source[key] as string)) {
          if (this.isDateString(source[key]))
            destination[key] = this.adjustForTimezone(source[key]);
          else
            destination[key] = source[key];
        }
        else if (destination[key] === undefined && (keepProperty == undefined || keepProperty === false))
          delete destination[key]
      }
      catch (e) { }
    })
    destination = this.copy(destination);
    return destination
  }

  static IsStringNotNullOrEmpty(value: string): boolean {
    return (value && value != null && value != undefined && value !== '' && value !== 'null' && value !== 'undefined' && value?.toString()?.trim() !== '') ? true : false
  }
  static IsNumberNotNullOrEmpty(value: number, isNegative: boolean = false): boolean {
    return (value && value != null && value != undefined && ((!isNegative && value > 0) || (isNegative && (value > 0 || value < 0)))) ? true : false
  }
  static IsArrayNotNullOrEmpty(value: any): boolean {
    return (value && value != null && value != undefined && value?.length > 0) ? true : false
  }

  static IsNotNullOrEmpty(value: any): boolean {
    return (value && value != null && value !== undefined) ? true : false
  }
  static IsNumber(value: any): boolean {
    return typeof (value) === 'number' ? true : false
  }

  static mapArrayToArray<Source, Destination>(sourceList: Source[], destination: Destination, keepProperty: boolean = false): Destination[] {
    let destinationList: Destination[] = [];
    sourceList.forEach((source: Source) => {
      let tempdestination = this.mapObject<Source, Destination>(source, destination, keepProperty);
      if (!keepProperty) tempdestination = this.copy(tempdestination);
      else tempdestination = this.mapObjectToObject<Destination, Destination>(tempdestination, tempdestination)
      if (Object.keys(tempdestination)?.length > 0)
        destinationList.push(JSON.parse(JSON.stringify(tempdestination)));
    })
    destinationList = this.copy(destinationList);
    return destinationList
  }

  static adjustForTimezone(value: string | number | Date): Date {
    var date = new Date(value);
    var timeOffsetInMS: number = date.getTimezoneOffset() * 60000;
    date.setTime(date.getTime() - timeOffsetInMS);
    return date
  }
  static mapArrayFromObject<Source, Destination>(sourceList: Source[], destination: Destination, keepProperty: boolean = false): Source[] {
    let destinationList: Source[] = [];
    sourceList.forEach((source: Source) => {
      Object.keys(source)?.forEach((key: string) => {
        try {
          if (destination[key]) {
            source[key] = destination[key];
          }
        }
        catch (e) { }
      });
    });
    return sourceList;
  }
  static mapObjectToObject<Source, Destination>(source: Source, destination: Destination): Destination {
    Object.keys(source)?.forEach((key) => {
      destination[key] = source[key];
    });
    destination = this.copy(destination);
    return destination
  }

  static postParams(data: any): any {
    Object.keys(data)?.forEach((key) => {
      try {
        if (data[key] === undefined || data[key] === null || data[key] === 'null')
          delete data[key]
      }
      catch (e) { }
    })
    return data
  }

  static GetParams(params?: HttpParams | { [param: string]: string | string[]; }): HttpParams {
    let paramsappend: HttpParams = new HttpParams();
    if (params) {
      if (params["updates"]) {
        for (let index in params["updates"]) {
          let param = params["updates"][index];
          if (param["param"] && param["value"] && param["value"] !== null && param["value"] !== 'null')
            paramsappend = paramsappend.append(param["param"], param["value"]);
        }
      }
      else {
        for (let key in params) {
          if (params[key] != undefined && params[key] !== null && params[key] !== 'null')
            paramsappend = paramsappend.append(key.toString(), params[key]);
        }
      }
    } else paramsappend = null;
    return paramsappend;
  }

  static isDateString(value: any): boolean {
    try {
      return value instanceof Date;
    }
    catch (e) {
      return false;
    }
  }

  static addDays(dateValue: Date, noOfDaysToAdd: number, setEndDate: boolean = false) {
    let date = new Date(dateValue);
    date.setDate(date.getDate() + noOfDaysToAdd);
    if (setEndDate == true) date = this.setEndDate(date);
    return date;
  }
  static dateDiffInDays(a: Date, b: Date) {
    a = new Date(a);
    b = new Date(b);
    const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

    return Math.floor((utc2 - utc1) / (1000 * 60 * 60 * 24));
  }

  static setEndDate(dateValue: Date) {
    return new Date(dateValue.getFullYear(), dateValue.getMonth(), dateValue.getDate(), 23, 59, 1);
  }

  static setStartDate(dateValue: Date) {
    return new Date(dateValue.getFullYear(), dateValue.getMonth(), dateValue.getDate(), 0, 0, 0);
  }

  static titleCase(string: any) {
    return string.toLowerCase().split(' ').map(function (word: any) {
      return (word.charAt(0)?.toUpperCase() + (word?.length > 1 ? word.slice(1) : ''));
    }).join(' ');;
  }

  static scrollInToView(el: any) {
    if (el && el instanceof HTMLElement)
      el.scrollIntoView({ behavior: "smooth" });
    else {
      window.scroll(0, 0);
      setTimeout(() => {
        let target = document.getElementById(el);
        if (target && target != null) target.scrollIntoView({ behavior: "smooth" });
      }, 300);
    }
  }

  static getCartesionRecords(arr: any[]) {
    return arr?.reduce(function (a, b) {
      return a?.map(function (x: any) {
        return b?.map(function (y: any) {
          return x?.concat([y]);
        })
      }).reduce(function (a: any, b: any) { return a?.concat(b) }, [])
    }, [[]])
  }

  static round(y: any, C: any) {
    let value = this.IsNumberNotNullOrEmpty(y, true) ? Number(Math.round(Number(y + "e" + C)) + "e" + -1 * C) : undefined
    return value !== undefined && !Number.isNaN(value) ? value : undefined;
  }

  static ToNumber(y: any) {
    return this.IsNumberNotNullOrEmpty(y, true) ? Number(y) : undefined
  }

  static reorderSelectedOnTop(options: any[], selectedValues: any[]): any[] {
    if (!Array.isArray(options)) return [];
    if (!Array.isArray(selectedValues) || selectedValues.length === 0) {
      return options;
    }
    const selected = options.filter(opt => selectedValues.includes(opt['id']));
    const unselected = options.filter(opt => !selectedValues.includes(opt['id']));
    return [...selected, ...unselected];
  }

  formatDate(date: Date): string {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

}
